import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { TypeContrato } from '@/features/agreement/utils/enum'
import { produtosLabelsTypeContract } from '@/features/products/utils'

export const getProdutosDisponiveis = (regimeTributario?: TypeContrato): TypeContrato[] => {
  if (regimeTributario === TypeContrato.SIMPLES_NACIONAL) {
    return [TypeContrato.PIS_COFINS_MONOFASICO_PARA_SN, TypeContrato.APURACAO_ST, TypeContrato.NEGOCIACAO_DE_PASSIVOS]
  }

  if (regimeTributario === TypeContrato.LUCRO_PRESUMIDO) {
    return [
      TypeContrato.PREVIDENCIARIO,
      TypeContrato.NEGOCIACAO_DE_PASSIVOS,
      // TypeContrato.INSS_MAO_DE_OBRA,
      TypeContrato.EXCLUSAO_DE_ICMS_E_ST,
      TypeContrato.EQUIPARACAO_HOSPITALAR
    ]
  }

  if (regimeTributario === TypeContrato.LUCRO_REAL) {
    return [
      TypeContrato.PREVIDENCIARIO,
      TypeContrato.NEGOCIACAO_DE_PASSIVOS,
      // TypeContrato.ALIQUOTA_ZERO,
      // TypeContrato.INSS_MAO_DE_OBRA,
      TypeContrato.EXCLUSAO_DE_ICMS_E_ST,
      TypeContrato.ALIQUOTA_ZERO_COMBUSTIVEL,
      TypeContrato.SUBVENCAO
      // TypeContrato.MVA
    ]
  }

  return []
}

export const getLabelRegimeTributario = (regime?: TypeContrato): string => {
  switch (regime) {
    case TypeContrato.PESSOA_FISICA:
      return 'Pessoa Física'
    case TypeContrato.LUCRO_REAL:
      return 'Lucro Real'
    case TypeContrato.LUCRO_PRESUMIDO:
      return 'Lucro Presumido'
    case TypeContrato.SIMPLES_NACIONAL:
      return 'Simples Nacional'
    default:
      return 'Não selecionado'
  }
}

interface ProdutosSelectorProps {
  regimeTributario: string | null
  selectedProducts: string[]
  onProductChange: (product: string) => void
  error?: string
  className?: string
  useIdsAsNames?: boolean
  produtosFixos?: string[] // <-- Adicionar isso
}

export const ProdutosSelector = ({
  regimeTributario,
  selectedProducts,
  onProductChange,
  error,
  className = '',
  useIdsAsNames = false,
  produtosFixos = [] // <-- Default vazio
}: ProdutosSelectorProps) => {
  const produtos = getProdutosDisponiveis(regimeTributario as TypeContrato)

  return (
    <div className={className}>
      <h3 className="text-lg font-semibold mb-2">Selecione os Produtos para o Contrato</h3>
      {produtos.length > 0 ? (
        <div className="space-y-2">
          {produtos.map(produto => {
            const id = useIdsAsNames ? produto.toLowerCase().replace(/\s+/g, '-') : produto
            const isFixed = produtosFixos.includes(produto)

            return (
              <div key={produto} className="flex items-center space-x-2">
                <Checkbox
                  id={id}
                  checked={selectedProducts.includes(produto)}
                  disabled={isFixed} // <-- Aqui desabilita se for fixo
                  onCheckedChange={() => onProductChange(produto)}
                />
                <Label htmlFor={id}>{produtosLabelsTypeContract[produto]}</Label>
              </div>
            )
          })}
        </div>
      ) : (
        <p className="text-sm text-gray-500">Selecione um regime tributário primeiro</p>
      )}
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  )
}
